import { useEffect, useState } from "react";
import AdminShell from "@/components/AdminShell";
import api from "@/lib/api";
import { toast } from "sonner";
import { Building2, CheckCircle2, Globe } from "lucide-react";

export default function AdminEmployers() {
  const [cos, setCos] = useState([]);
  const load = () => api.get("/admin/employers").then((r) => setCos(r.data));
  useEffect(() => { load(); }, []);
  const verify = async (id) => { await api.post(`/admin/employers/${id}/verify`); toast.success("Employer verified"); load(); };

  return (
    <AdminShell>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-5">Employer Management</h1>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-slate-400 bg-slate-50 border-b border-slate-100"><th className="py-3 px-4 font-medium">Company</th><th className="py-3 px-4 font-medium">Industry</th><th className="py-3 px-4 font-medium">Locations</th><th className="py-3 px-4 font-medium">Status</th><th className="py-3 px-4 font-medium">Action</th></tr></thead>
          <tbody>
            {cos.map((c) => (
              <tr key={c.company_id} data-testid={`employer-${c.company_id}`} className="border-b border-slate-50 hover:bg-slate-50">
                <td className="py-3 px-4">
                  <div className="flex items-center gap-2"><div className="w-8 h-8 rounded bg-slate-100 flex items-center justify-center"><Building2 className="w-4 h-4 text-slate-500" /></div><div><div className="font-medium text-slate-800">{c.name}</div>{c.website && <a href={c.website} className="text-xs text-slate-400 flex items-center gap-1"><Globe className="w-3 h-3" />{c.website}</a>}</div></div>
                </td>
                <td className="py-3 px-4 text-slate-600">{c.industry}</td>
                <td className="py-3 px-4 text-slate-600">{(c.plant_locations || []).join(", ")}</td>
                <td className="py-3 px-4">{c.verified ? <span className="text-xs bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded flex items-center gap-1 w-fit"><CheckCircle2 className="w-3 h-3" />Verified</span> : <span className="text-xs bg-amber-50 text-amber-700 px-2 py-0.5 rounded">{c.status}</span>}</td>
                <td className="py-3 px-4">{!c.verified && <button onClick={() => verify(c.company_id)} data-testid={`verify-${c.company_id}`} className="text-xs copper-gradient text-white px-3 py-1.5 rounded-md">Verify</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminShell>
  );
}
